import { render } from "./sideMenuBar.vue?vue&type=template&id=642ddee8"
import script from "./sideMenuBar.vue?vue&type=script&lang=js"
export * from "./sideMenuBar.vue?vue&type=script&lang=js"

import "./sideMenuBar.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__